import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    guests: [],
    pageSize: 0,
    next: '',
    count: 0,
    newCount: 0,
    errors: {}
};

getters['fetchGuests'] = function(state) { return state.guests }
getters['fetchGuestsNext'] = function(state) { return state.next }
getters['fetchGuestsPageSize'] = function(state) { return state.pageSize }
getters['fetchGuestsCount'] = function(state) { return state.count }
getters['fetchGuestsNewCount'] = function(state) { return state.newCount }

const actions = {
    get(context) {
        return ApiService
            .get('guests/', false, false)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('SET_GUESTS', response.data.results);
                context.commit('SET_PAGE_SIZE', response.data.page_size);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param,
                ]);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('ADD_GUESTS', response.data.results);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    clear(context) {
        return ApiService
            .delete('guests/clear/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_GUESTS', []);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_GUESTS(state, guests) {
        state.guests = guests;
        state.errors = {};
    },
    ADD_GUESTS(state, guests) {
        state.guests = state.guests.concat(guests);
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
    },
    SET_NEW_COUNT(state, guests) {
        state.newCount = 0;
        const cloneGuests = guests.slice();
        for (let i in cloneGuests) {
            if (cloneGuests[i].viewed === false) {
                state.newCount++;
            }
        }
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.pageSize = pageSize;
    },
    SET_NEXT(state, [page, num_pages, url, page_param]) {
        if (page < num_pages) {
            state.next =
            url +
            '?' +
            page_param +
            '=' +
            (page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
